<template>
  <div>
    <div class="router-content page-right-header">
      <vs-button color="primary" type="filled" @click="showAddEditDialog = true"
        >Add Partie</vs-button
      >
    </div>
    <vs-popup
      class="holamundo digitelex-popup"
      :title="modalTitle"
      :active.sync="showAddEditDialog"
    >
      <addEditClient
        :frmData="currentEditRow ? currentEditRow : formData"
        v-if="showAddEditDialog"
        @submitResponse="reloadData"
      ></addEditClient>
    </vs-popup>
    <div id="ag-grid-demo">
      <vx-card>
        <!-- TABLE ACTION ROW -->
        <div class="flex flex-wrap justify-between items-center">
          <!-- ITEMS PER PAGE -->
          <div class="mb-4 md:mb-0 mr-4 ag-grid-table-actions-left">
            <vs-dropdown vs-trigger-click class="cursor-pointer">
              <div
                class="
                  p-4
                  border border-solid
                  d-theme-border-grey-light
                  rounded-full
                  d-theme-dark-bg
                  cursor-pointer
                  flex
                  items-center
                  justify-between
                  font-medium
                "
              >
                <span class="mr-2">
                  {{
                    currentPage * paginationPageSize - (paginationPageSize - 1)
                  }}
                  -
                  {{
                    clients.length - currentPage * paginationPageSize > 0
                      ? currentPage * paginationPageSize
                      : clients.length
                  }}
                  of {{ clients.length }}
                </span>
                <feather-icon icon="ChevronDownIcon" svgClasses="h-4 w-4" />
              </div>
              <!-- <vs-button class="btn-drop" type="line" color="primary" icon-pack="feather" icon="icon-chevron-down"></vs-button> -->
              <vs-dropdown-menu>
                <vs-dropdown-item @click="gridApi.paginationSetPageSize(20)">
                  <span>20</span>
                </vs-dropdown-item>
                <vs-dropdown-item @click="gridApi.paginationSetPageSize(50)">
                  <span>50</span>
                </vs-dropdown-item>
                <vs-dropdown-item @click="gridApi.paginationSetPageSize(100)">
                  <span>100</span>
                </vs-dropdown-item>
                <vs-dropdown-item @click="gridApi.paginationSetPageSize(150)">
                  <span>150</span>
                </vs-dropdown-item>
              </vs-dropdown-menu>
            </vs-dropdown>
          </div>

          <!-- TABLE ACTION COL-2: SEARCH & EXPORT AS CSV -->
          <div
            class="
              flex flex-wrap
              items-center
              justify-between
              ag-grid-table-actions-right
            "
          >
            <vs-input
              class="mb-4 md:mb-0 mr-4"
              v-model="searchQuery"
              @input="updateSearchQuery"
              placeholder="Search..."
            />
            <vs-button class="mb-4 md:mb-0" @click="gridApi.exportDataAsCsv()"
              >Export as CSV</vs-button
            >
          </div>
        </div>
        <ag-grid-vue
          ref="agGridTable"
          :gridOptions="gridOptions"
          class="ag-theme-material w-100 my-4 ag-grid-table"
          :columnDefs="columnDefs"
          :defaultColDef="defaultColDef"
          :rowData="clients"
          rowSelection="multiple"
          colResizeDefault="shift"
          :animateRows="true"
          :floatingFilter="true"
          :pagination="true"
          :paginationPageSize="paginationPageSize"
          :suppressPaginationPanel="true"
          :context="context"
          :tooltipShowDelay="'0'"
          :overlayLoadingTemplate="overlayLoadingTemplate"
          :overlayNoRowsTemplate="overlayNoRowsTemplate"
        ></ag-grid-vue>
        <vs-pagination
          :total="totalPages"
          :max="maxPageNumbers"
          v-model="currentPage"
        />
      </vx-card>
    </div>
  </div>
</template>

<script>
import { AgGridVue } from "ag-grid-vue";
import "@/assets/scss/vuexy/extraComponents/agGridStyleOverride.scss";
import { EventBus } from "./../../../utils/grid/eventbus.js";
import addEditClient from "./add-edit-client";

// define cellRenderer to be reused
//  @close="close" -> For popup props
let actionsTemplate = {
  template: `<div class="flex">
      <vs-button class="w-1/2 h-12 flex"  @click="editClient" size="large"radius color="primary" type="flat" icon-pack="feather" icon="icon-edit"></vs-button>
      <vs-button class="w-1/2 h-12 flex" @click="deleteClient" size="large"radius color="danger" type="flat" icon-pack="feather" icon="icon-trash"></vs-button>
    </div>`,
  methods: {
    editClient() {
      EventBus.$emit("editClient", { item: this.params });
    },
    deleteClient() {
      EventBus.$emit("deleteClient", { item: this.params });
    },
  },
  beforeMount() {},
};
export default {
  components: {
    "ag-grid-vue": AgGridVue,
    // eslint-disable-next-line vue/no-unused-components
    actionsTemplate: actionsTemplate,
    addEditClient: addEditClient,
  },
  beforeMount() {
    // this.gridApi.showLoadingOverlay();
    this.overlayLoadingTemplate =
      '<span class="ag-overlay-loading-center">Please wait while loading Clients</span>';
    this.overlayNoRowsTemplate =
      '<span class="ag-overlay-loading-center">No Client found!</span>';
    this.context = {
      componentParent: this,
    };
  },
  data() {
    return {
      showAddEditDialog: false,
      currentEditRow: null,
      searchQuery: "",
      gridOptions: {},
      maxPageNumbers: 7,
      gridApi: null,
      context: null,
      modalTitle: "Add Partie",
      formData: {
        address: null,
        billingAddress: null,
        billingName: null,
        clientContactPersonMobileNo: null,
        clientContactPersonName: null,
        clientId: 0,
        clientName: null,
        clientUniq: null,
        email: null,
        gstNo: null,
        isActive: true,
        locationId: -1,
        locationName: null,
        mobileNo: null,
        needEmail: false,
        needMessage: false,
        needWhatsapp: false,
        sendGreetings: false,
        zipCode: null,
      },
      overlayLoadingTemplate: null,
      overlayNoRowsTemplate: null,
      defaultColDef: {
        sortable: true,
        editable: false,
        resizable: true,
        suppressMenu: true,
      },
      columnDefs: [
        {
          headerName: "Actions",
          width: 150,
          filter: false,
          pinned: "left",
          cellRendererFramework: "actionsTemplate",
        },
        {
          headerName: "Name",
          field: "clientName",
          width: 200,
          filter: true,
          tooltipField: "clientName",
          pinned: "left",
        },
        {
          headerName: "Mobile No",
          headerTooltip: "Mobile No",
          field: "mobileNo",
          filter: true,
          width: 125,
          tooltipField: "mobileNo",
        },
        {
          headerName: "Contact Person Name",
          headerTooltip: "Contact Person Name",
          field: "clientContactPersonName",
          filter: true,
          width: 200,
          tooltipField: "clientContactPersonName",
        },
        {
          headerName: "Contact Mobile No",
          field: "clientContactPersonMobileNo",
          headerTooltip: "Contact Mobile No",
          filter: true,
          width: 200,
          tooltipField: "clientContactPersonMobileNo",
        },
        {
          headerName: "GST No",
          field: "gstNo",
          filter: true,
          width: 180,
          tooltipField: "gstNo",
        },
        {
          headerName: "Address",
          field: "address",
          filter: true,
          width: 250,
          tooltipField: "address",
        },
        {
          headerName: "Pin Code",
          field: "zipCode",
          filter: true,
          width: 150,
          tooltipField: "zipCode",
        },
        {
          headerName: "Location",
          field: "locationName",
          filter: true,
          width: 150,
          tooltipField: "locationName",
        },
        {
          headerName: "Billing Name",
          field: "billingName",
          filter: true,
          width: 250,
          tooltipField: "billingName",
        },
        {
          headerName: "Billing Address",
          field: "billingAddress",
          filter: true,
          width: 250,
          tooltipField: "billingAddress",
        },
        {
          headerName: "Text Message",
          headerTooltip: "Send Text Message",
          field: "needMessage",
          filter: true,
          width: 100,
          valueFormatter: (_params) => {
            if (_params.value == 1) {
              return "Yes";
            } else {
              return "NO";
            }
          },
        },
        {
          headerName: "Whatsapp Message",
          headerTooltip: "Whatsapp Message",
          field: "needWhatsapp",
          filter: true,
          width: 100,
          valueFormatter: (_params) => {
            if (_params.value == 1) {
              return "Yes";
            } else {
              return "NO";
            }
          },
        },
        {
          headerName: "Send Email ",
          headerTooltip: "Send Email",
          field: "needEmail",
          filter: true,
          width: 100,
          valueFormatter: (_params) => {
            if (_params.value == 1) {
              return "Yes";
            } else {
              return "NO";
            }
          },
        },
        {
          headerName: "Send  Greetings",
          headerTooltip: "Send Greetings",
          field: "sendGreetings",
          filter: true,
          width: 100,
          valueFormatter: (_params) => {
            if (_params.value == 1) {
              return "Yes";
            } else {
              return "NO";
            }
          },
        },
      ],
      clients: [],
    };
  },
  watch: {
    "$store.state.windowWidth"(val) {
      if (val <= 576) {
        this.maxPageNumbers = 4;
        this.gridOptions.columnApi.setColumnPinned("clientName", null);
      } else this.gridOptions.columnApi.setColumnPinned("clientName", "left");
    },
    showAddEditDialog: function () {
      Object.keys(this.formData).forEach((key) => {
        if (typeof key === "string") this.formData[key] = "";
        else if (typeof key === "boolean") this.formData[key] = false;
        else if (typeof key === "number") this.formData[key] = 0;
        else this.formData[key] = "";
      });
      if (!this.showAddEditDialog) {
        this.currentEditRow = false;
      }
    },
  },
  computed: {
    paginationPageSize() {
      if (this.gridApi) return this.gridApi.paginationGetPageSize();
      else return 10;
    },
    totalPages() {
      if (this.gridApi) return this.gridApi.paginationGetTotalPages();
      else return 0;
    },
    currentPage: {
      get() {
        if (this.gridApi) return this.gridApi.paginationGetCurrentPage() + 1;
        else return 1;
      },
      set(val) {
        this.gridApi.paginationGoToPage(val - 1);
      },
    },
  },
  methods: {
    updateSearchQuery(val) {
      this.gridApi.setQuickFilter(val);
    },
    reloadData(_event) {
      this.showAddEditDialog = false;
      this.clients = _event.data.data;
      this.$vs.notify({
        title: _event.data.message,
        color: "success",
        position: "top-right",
      });
      this.gridApi.setRowData(_event.data.data);
    },
    deleteClient(_e) {
      console.log(_e);
      this.$http
        .put("portage/client", _e.data)
        .then((response) => {
          // text:'Lorem ipsum dolor sit amet, consectetur',

          this.$vs.notify({
            title: response.data.message,
            color: "success",
            position: "top-right",
          });
          this.gridApi.setRowData(response.data.data);
          // this.$emit("submitResponse", response);
        })
        .catch((error) => {
          console.log(error);
        });
    },
  },

  mounted() {
    this.gridApi = this.gridOptions.api;
    this.gridApi.showLoadingOverlay();
    this.$http.get("portage/clients").then((response) => {
      if (response.data.data.length > 0) {
        this.gridApi.hideOverlay();
        this.clients = response.data.data;
      } else {
        this.gridApi.showNoRowsOverlay();
      }
    });
    EventBus.$on("editClient", (clientData) => {
      this.currentEditRow = clientData.item.data;
      this.showAddEditDialog = true;
    });
    EventBus.$on("deleteClient", (clientData) => {
      // this.currentEditRow = clientData.item.data;
      let rowData = clientData;
      rowData.item.data.isActive = false;
      console.log(clientData);
      this.$vs.dialog({
        type: "confirm",
        color: "danger",
        title: `Delete Client?`,
        text: ``,
        acceptText: "Accept!",
        accept: this.deleteClient,
        parameters: rowData.item,
      });
      setTimeout(() => {
        if (document.getElementsByClassName("vs-dialog-text").length > 0) {
          document.getElementsByClassName(
            "vs-dialog-text"
          )[0].innerHTML = `Do you want to delete below Client?<br/><blockquote>Client Name: <b>${clientData.item.data.clientName}</b></blockquote>`;
        }
      }, 0);
    });
  },
};
</script>
 <style scoped>
.digitelex-popup .vs-popup {
  width: 56vw;
}
</style>